import { getUnixTime } from 'date-fns';

export const getEpgItemPlayerUrl = (item, type) => (item.isNowPlaying)
  ? (`/${type}/player/${item.channels_id}`)
  : (`/${type}/player/${item.channels_id}/${getUnixTime(new Date(item.start || item.start))}`);
